import type { Circuit, PlayerTrackPosition } from '../types/track.js';
import { trackMovementOccupancyKey } from './trackOccupancyKey.js';

/** Met à jour le tampon d’arrivée dès que la case *path* change (pas seulement
 * la clé d’occupation cluster — sinon un −0.5 de dépassement survit trop longtemps
 * en se déplaçant dans le même cornerCluster). */
export function shouldUpdateArrivalStampOnMove(
  circuit: Circuit,
  from: PlayerTrackPosition,
  to: PlayerTrackPosition
): boolean {
  if (from.startLaneIndex != null || to.startLaneIndex != null) {
    return from.startLaneIndex !== to.startLaneIndex;
  }
  if (from.jokerBranchIndex != null || to.jokerBranchIndex != null) {
    return from.jokerBranchIndex !== to.jokerBranchIndex || from.mainPathIndex !== to.mainPathIndex;
  }
  if (from.mainPathIndex !== to.mainPathIndex) return true;
  const fromKey = trackMovementOccupancyKey(circuit, from);
  const toKey = trackMovementOccupancyKey(circuit, to);
  if (!fromKey || !toKey) return true;
  return fromKey !== toKey;
}

export function applyAttackerPriorityStamp(
  stamps: number[],
  attackerIndex: number,
  defenderIndex: number
): void {
  const defenderStamp = stamps[defenderIndex] ?? 0;
  stamps[attackerIndex] = defenderStamp - 0.5;
}

export function applyArrivalStampAfterMove(
  stamps: number[],
  arrivalSeqCounter: number,
  playerIndex: number,
  from: PlayerTrackPosition,
  to: PlayerTrackPosition,
  circuit: Circuit,
  priorityDefenderIndex: number | null
): number {
  if (priorityDefenderIndex != null) {
    applyAttackerPriorityStamp(stamps, playerIndex, priorityDefenderIndex);
    return arrivalSeqCounter;
  }
  if (shouldUpdateArrivalStampOnMove(circuit, from, to)) {
    stamps[playerIndex] = arrivalSeqCounter;
    return arrivalSeqCounter + 1;
  }
  return arrivalSeqCounter;
}
